module.exports = __webpack_public_path__ + "static/media/roadbike.20b506c4.avif";